module.exports = __webpack_public_path__ + "static/media/1012242.43ec995f.jpg";